import { render, staticRenderFns } from "./FAQView.vue?vue&type=template&id=1a8f052e"
import script from "./FAQView.vue?vue&type=script&lang=ts"
export * from "./FAQView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports